module.exports = __webpack_public_path__ + "static/media/azerbaijan.d60bf123.svg";